import { gql } from '@apollo/client';

export default gql`
  mutation SignOut {
    signOut @rest(type: "User", path: "auth/signout", method: "DELETE") {
      NoResponse
    }
  }
`;
